import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const QualityControlSection = ({ formData, onChange, errors }) => {
  const handleInputChange = (field, value) => {
    onChange({ ...formData, [field]: value });
  };

  const calculateRejectionRate = () => {
    const total = parseFloat(formData?.totalMilkReceived) || 0;
    const rejected = parseFloat(formData?.rejectedMilk) || 0;
    if (total === 0) return 0;
    return ((rejected / total) * 100)?.toFixed(2);
  };

  const calculatePassRate = () => {
    const rate = parseFloat(calculateRejectionRate());
    return (100 - rate)?.toFixed(2);
  };

  return (
    <div className="card space-y-6">
      <div className="flex items-center gap-3 pb-4 border-b border-border">
        <div className="w-12 h-12 rounded-xl bg-accent/10 flex items-center justify-center">
          <Icon name="ClipboardCheck" size={24} color="var(--color-accent)" />
        </div>
        <div>
          <h2 className="text-xl font-semibold">Kontrol Kualitas & Penolakan</h2>
          <p className="text-sm text-muted-foreground">Tracking kualitas susu dan tingkat penolakan</p>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label="Total Susu Diterima (Liter/Bulan)"
          type="number"
          placeholder="Contoh: 150000"
          value={formData?.totalMilkReceived || ''}
          onChange={(e) => handleInputChange('totalMilkReceived', e?.target?.value)}
          error={errors?.totalMilkReceived}
          required
          description="Volume total susu yang diterima per bulan"
        />

        <Input
          label="Susu Ditolak (Liter/Bulan)"
          type="number"
          placeholder="Contoh: 3000"
          value={formData?.rejectedMilk || ''}
          onChange={(e) => handleInputChange('rejectedMilk', e?.target?.value)}
          error={errors?.rejectedMilk}
          required
          description="Volume susu yang ditolak karena kualitas"
        />

        <Input
          label="Jumlah Checkpoint Kualitas"
          type="number"
          placeholder="Contoh: 5"
          value={formData?.qualityCheckpoints || ''}
          onChange={(e) => handleInputChange('qualityCheckpoints', e?.target?.value)}
          error={errors?.qualityCheckpoints}
          required
          description="Titik pemeriksaan kualitas dalam proses"
        />

        <Input
          label="Frekuensi Testing (Per Hari)"
          type="number"
          placeholder="Contoh: 12"
          value={formData?.testingFrequency || ''}
          onChange={(e) => handleInputChange('testingFrequency', e?.target?.value)}
          error={errors?.testingFrequency}
          required
          description="Berapa kali testing dilakukan per hari"
        />

        <Input
          label="Waktu Rata-rata Testing (Menit)"
          type="number"
          placeholder="Contoh: 15"
          value={formData?.avgTestingTime || ''}
          onChange={(e) => handleInputChange('avgTestingTime', e?.target?.value)}
          error={errors?.avgTestingTime}
          description="Durasi rata-rata untuk setiap testing"
        />

        <Input
          label="Jumlah Staff QC"
          type="number"
          placeholder="Contoh: 3"
          value={formData?.qcStaff || ''}
          onChange={(e) => handleInputChange('qcStaff', e?.target?.value)}
          error={errors?.qcStaff}
          description="Tenaga kerja khusus quality control"
        />
      </div>
      {formData?.totalMilkReceived && formData?.rejectedMilk && (
        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-4 rounded-lg bg-error/10 border border-error/20">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground mb-1">Tingkat Penolakan</p>
                <p className="text-3xl font-bold text-error data-text">{calculateRejectionRate()}%</p>
              </div>
              <Icon name="XCircle" size={32} color="var(--color-error)" />
            </div>
            <p className="text-xs text-muted-foreground mt-2">
              {parseFloat(calculateRejectionRate()) > 5 ? 'Tinggi - Perlu perbaikan' : 'Normal'}
            </p>
          </div>

          <div className="p-4 rounded-lg bg-success/10 border border-success/20">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground mb-1">Tingkat Lolos QC</p>
                <p className="text-3xl font-bold text-success data-text">{calculatePassRate()}%</p>
              </div>
              <Icon name="CheckCircle2" size={32} color="var(--color-success)" />
            </div>
            <p className="text-xs text-muted-foreground mt-2">
              {parseFloat(calculatePassRate()) >= 95 ? 'Sangat Baik' : 'Perlu Peningkatan'}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default QualityControlSection;